import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  VStack,
} from '@chakra-ui/react';
import { ChatData } from 'modules/common/components/Chat/Chat.types';
import { Dispatch, SetStateAction, useRef } from 'react';

import { TestChatMessages } from './TestChatMessages';
import { TestDesignGeneration } from './TestDesignGeneration';

type DebugPanelProps = {
  isOpen: boolean;
  chatData: ChatData[];
  setChatData: Dispatch<SetStateAction<ChatData[]>>;
  onClose: () => void;
};
export const DebugPanel = ({ isOpen, onClose, chatData, setChatData }: DebugPanelProps) => {
  const btnRef = useRef<HTMLButtonElement>(null);

  if (!isOpen) {
    return null;
  }
  return (
    <>
      <Drawer isOpen={isOpen} placement='right' onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Debug Panel</DrawerHeader>

          <DrawerBody>
            <VStack alignItems='flex-start'>
              <Heading as='h2' fontSize='lg'>
                Test Chat messages
              </Heading>
              <TestChatMessages chatData={chatData} setChatData={setChatData} />

              <Heading as='h2' fontSize='lg'>
                Test Design generation
              </Heading>
              <TestDesignGeneration chatData={chatData} setChatData={setChatData} />
            </VStack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant='outline' mr={3} onClick={onClose}>
              Close
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

DebugPanel.displayName = 'DebugPanel';
